var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkLeftChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3995 19.1999C15.0923 19.1999 14.7851 19.0823 14.5511 18.8483L8.55112 12.8483C8.08192 12.3791 8.08192 11.6207 8.55112 11.1515L14.5511 5.15146C15.0203 4.68226 15.7787 4.68226 16.2479 5.15146C16.7171 5.62066 16.7171 6.37906 16.2479 6.84826L11.0963 11.9999L16.2479 17.1515C16.7171 17.6207 16.7171 18.3791 16.2479 18.8483C16.0139 19.0823 15.7067 19.1999 15.3995 19.1999Z",
    fill: "#182027"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLeftChevron);
export default __webpack_public_path__ + "static/media/darkLeftChevron.b4507f46493f6f7ed9e0c2f56473d768.svg";
export { ForwardRef as ReactComponent };